// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"2f4467b0","320":"d624bd51"}[chunkId] + ".chunk.js";
};